module.exports = __webpack_public_path__ + "img/info.ba18a56c.svg";